module.exports = __webpack_public_path__ + "static/crosses-154220ba52aedcc711e2700e433caba9.jpg";